import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import Navbar from './components/Navbar';
import PrivacyPolicy from './PrivacyPolicy';
import RegisterForm from './components/RegisterForm';
import AccountDeletionPage from './components/AccountDeletionPage';
import KapcsolatOldal from './components/Contacts';
import CreateCompetitionPage from './components/CreateCompetitionPage';
import EventsListPage from './components/EventsListPage';
import FullViewCompetition from './components/FullViewCompetition';
import BottomNavbar from './components/BottomNavbar';
import QrScannerWeb from './components/competitors/QrScannerWeb';
import CompetitionScoringWeb from './components/competitors/CompetitionScoringWeb';
import MyWorkouts from './components/competitors/MyWorkouts';
import WorkoutDetails from './components/competitors/WorkoutDetails';
import ResultsListPage from './components/competitors/ResultsListPage';
import ClosedCompetitionLeaderboard from './components/competitors/ClosedCompetitionLeaderboard';

import HomePage from './components/HomePage';

import ClubDashboard from './components/clubs/ClubDashboard';
import EditCompetitionPage from './components/clubs/EditCompetitionPage'; 
import CompetitionOffice from './components/clubs/CompetitionOffice';

import CompetitorDashboard from './components/competitors/CompetitorDashboard.js';

import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { ALLOWED_UIDS } from './constants/Whitelist';

function useWhitelistGatekeeper() {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && !ALLOWED_UIDS.includes(user.uid)) {
        console.warn("Hozzáférés megtagadva: UID nincs a fehérlistán.");
        await signOut(auth);
      }
    });
    return () => unsubscribe();
  }, []);
}

function CompetitorRouteWrapper() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && ALLOWED_UIDS.includes(user.uid)) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const data = userDoc.data();
            setCurrentUser({
              ...user,
              displayName: `${data.lastName || ''} ${data.firstName || ''}`.trim() || user.displayName
            });
          } else {
            setCurrentUser(user);
          }
        } catch (e) {
          setCurrentUser(user);
        }
      } else {
        setCurrentUser(null);
      }
      setLoadingUser(false);
    });
    return () => unsubscribe();
  }, []);

  if (loadingUser) {
    return <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'Arial' }}>Felhasználó ellenőrzése... 🏹</div>;
  }

  if (!currentUser) {
    return <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'Arial' }}>Kérlek jelentkezz be a profil eléréséhez!</div>;
  }

  return <CompetitorDashboard currentUser={currentUser} onLogout={() => auth.signOut()} />;
}


function App() {
  useWhitelistGatekeeper();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    return () => {
      window.removeEventListener('resize', handleResize);
      unsubscribe();
    };
  }, []);

  return (
    <APIProvider apiKey={'AIzaSyCUQ1dNjylL6QZRs6nWbVyfKRSarbEXgKI'} libraries={['places', 'marker']}>
      <div className="force-light-theme" style={{ minHeight: '100vh' }}>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/adatvedelem" element={<PrivacyPolicy />} />
            <Route path="/regisztracio" element={<RegisterForm />} />
            <Route path="/fioktorles" element={<AccountDeletionPage />} />
            <Route path="/kapcsolat" element={<KapcsolatOldal />} />
            <Route path="/verseny-letrehozas" element={<CreateCompetitionPage />} />
            <Route path="/verseny-szerkesztes/:id" element={<EditCompetitionPage />} />
            <Route path="/versenyiroda/:id" element={<CompetitionOffice />} />
            <Route path="/versenyek" element={<EventsListPage />} />
            <Route path="/verseny/:id" element={<FullViewCompetition />} />
            <Route path="/egyesulet-dashboard" element={<ClubDashboard />} />
            <Route path="/profil" element={<CompetitorRouteWrapper />} />
            <Route path="/edzeseim" element={<MyWorkouts />} />
            <Route path="/edzes/:id" element={<WorkoutDetails />} />
            <Route path="/eredmenyek" element={<ResultsListPage />} />
            <Route path="/eredmeny/:id" element={<ClosedCompetitionLeaderboard />} />
            <Route path="/qr-scanner" element={<QrScannerWeb />} />
            <Route path="/competition-scoring-web" element={<CompetitionScoringWeb />} />
            <Route
              path="/nevezes/:eventId"
              element={<div>Nevezési oldal (Fejlesztés alatt)</div>}
            />
          </Routes>

          {isMobile && currentUser && <BottomNavbar />}
        </Router>
      </div>
    </APIProvider>
  );
}

export default App;
